import { render, staticRenderFns } from "./ReporteFactura.vue?vue&type=template&id=b5b6c9d2"
import script from "./ReporteFactura.vue?vue&type=script&lang=js"
export * from "./ReporteFactura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports